<script setup lang="ts">
import Translation from "@/i18n/translate";

Translation.initUserLocale();
</script>

<template>
  <RouterView />
</template>

<style lang="scss" scoped>
.notification {
  position: fixed;
  top: 96px !important;
}

.notification-enter-active {
  transition: all 0.3s ease-out;
}

.notification-leave-active {
  transition: all 0.8s ease-out;
}

.notification-enter-from,
.notification-leave-to {
  opacity: 0;
  transform: translateX(400px);
}
</style>
